class MapperFacade {
  constructor(mapper) {
    this.mapper = mapper;
  }
  map(sourceObject, sourceIdentifier, destinationIdentifier, options) {
    return this.mapper.map(sourceObject, sourceIdentifier, destinationIdentifier, options);
  }
  tryMap(sourceObject, sourceIdentifier, destinationIdentifier, options) {
    const rawModel = sourceObject ? JSON.stringify(sourceObject, null, 2) : null;
    try {
      const model = this.mapper.map(sourceObject, sourceIdentifier, destinationIdentifier, options);
      return { model, isModelValid: true, rawModelString: rawModel };
    } catch {
      return { model: null, isModelValid: false, rawModelString: rawModel };
    }
  }
  mapArray(sourceArray, sourceIdentifier, destinationIdentifier, options) {
    return this.mapper.mapArray(sourceArray, sourceIdentifier, destinationIdentifier, options);
  }
  tryMapArray(sourceArray, sourceIdentifier, destinationIdentifier, options) {
    const rawModel = sourceArray ? JSON.stringify(sourceArray, null, 2) : null;
    try {
      const model = this.mapper.mapArray(sourceArray, sourceIdentifier, destinationIdentifier, options);
      return { model, isModelValid: true, rawModelString: rawModel };
    } catch {
      return { model: null, isModelValid: false, rawModelString: rawModel };
    }
  }
  mutate(sourceObject, destinationObject, sourceIdentifier, destinationIdentifier, options) {
    return this.mapper.mutate(sourceObject, destinationObject, sourceIdentifier, destinationIdentifier, options);
  }
  tryMutate(sourceObject, destinationObject, sourceIdentifier, destinationIdentifier, options) {
    const rawModel = sourceObject ? JSON.stringify(sourceObject, null, 2) : null;
    try {
      this.mapper.mutate(sourceObject, destinationObject, sourceIdentifier, destinationIdentifier, options);
      return { model: destinationObject, isModelValid: true, rawModelString: rawModel };
    } catch {
      return { model: null, isModelValid: false, rawModelString: rawModel };
    }
  }
}
export {
  MapperFacade
};
//# sourceMappingURL=MapperFacade.js.map
